import { SortType } from '@/models/SortType';
import { HistoriqueReclamation, SuiviReclamation } from '@/models/SuiviReclamation';
import { TableHeader } from '@/models/TableHeader';

export interface SuiviReclamationState {
    reclamations: SuiviReclamation[];
    tableHeader: TableHeader[];
    page: number;
    nbOfPages: number;
    scroll: number;
    count: number,

    sort?: {
        sortData: string;
        sortStatus: SortType;
    };
    filterSite: number[];
    filterStatus: string[];

    isLoading: boolean;
    isExportLoading: boolean;
    error?: Error;
    success: boolean;

    historiques: HistoriqueReclamation[];
}

export const initialState: SuiviReclamationState = {
    reclamations: [],

    tableHeader: [
        {
            label: 'reclamation.suivi.id',
            sortData: 'id',
            sortStatus: SortType.DESC,
            width: '10%',
        },
        {
            label: 'reclamation.suivi.creationDate',
            sortData: 'dateEmission',
            sortStatus: SortType.NONE,
            width: '10%',
        },
        {
            label: 'reclamation.suivi.description',
            sortData: 'description',
            sortStatus: SortType.NONE,
            width: '60%',
        },
        {
            label: 'reclamation.suivi.emitter',
            sortData: 'emetteur',
            sortStatus: SortType.NONE,
            width: '10%',
        },
        {
            label: 'reclamation.suivi.recipient',
            sortData: 'destinataire',
            sortStatus: SortType.NONE,
            width: '10%',
        },
        {
            label: 'reclamation.suivi.status',
            sortData: 'etat',
            sortStatus: SortType.NONE,
            width: '10%',
            regleCle: 'suiviReclamation.colonneEtat',
        },
    ],
    page: 0,
    nbOfPages: 0,
    scroll: 0,
    count: 0,

    filterSite: [],
    filterStatus: [],

    isLoading: false,
    isExportLoading: false,
    success: false,
    historiques: [],
};

export const state: SuiviReclamationState = {
    ...initialState
};
